import type { ComparisonConfig } from './ComparisonPage';


const INNROAD_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io vs innRoad',
  heroSubtitle: 'innRoad es un PMS en la nube estadounidense para hoteles independientes con un conjunto básico de funciones. HotelStack.io ofrece 36 módulos incluyendo gestión avanzada de ingresos, A&B/POS, soporte multi-propiedad y cumplimiento global — a un precio comparable.',
  overviewComparison: [
    { label: 'Módulos Totales', hotelstack: '36 Módulos Integrados', competitor: 'Más de 8 Funciones Principales' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: 'Desde $100+/mes' },
    { label: 'Multi-Propiedad', hotelstack: 'Gestión de Cadena Completa', competitor: 'No Soportado' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'No Disponible' },
    { label: 'Alcance Global', hotelstack: 'Más de 40 Países', competitor: 'Enfocado en EE.UU.' },
    { label: 'Gestión de Ingresos', hotelstack: 'Avanzada (Integrada)', competitor: 'Herramientas de Tarifas Básicas' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'PMS en la Nube', hotelstack: true, competitor: true },
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Gestión de Reservas', hotelstack: true, competitor: true },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: true },
        { name: 'Gestión de Folio del Huésped', hotelstack: true, competitor: true },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Distribución y Reservas',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'OTAs Limitadas' },
        { name: 'Conectividad GDS', hotelstack: true, competitor: true },
        { name: 'Motor de Reservas Sin Comisión', hotelstack: true, competitor: true },
        { name: 'Reservas Grupales', hotelstack: true, competitor: 'Básico' },
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: 'Limitado' },
      ],
    },
    {
      category: 'Gestión de Ingresos',
      features: [
        { name: 'Reglas de Precios Dinámicos', hotelstack: true, competitor: 'Básico' },
        { name: 'Simulador de Ingresos Hipotético', hotelstack: true, competitor: false },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: false },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: false },
        { name: 'Analíticas RevPAR', hotelstack: true, competitor: 'Básico' },
      ],
    },
    {
      category: 'Operaciones y A&B',
      features: [
        { name: 'Terminal POS', hotelstack: true, competitor: false },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: false },
        { name: 'Gestión de Limpieza', hotelstack: true, competitor: 'Básico' },
        { name: 'Órdenes de Trabajo de Mantenimiento', hotelstack: true, competitor: false },
        { name: 'Programación de Personal', hotelstack: true, competitor: false },
        { name: 'Sistema de Pantalla de Cocina', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Informes y Cumplimiento',
      features: [
        { name: 'Informe Rápido', hotelstack: true, competitor: true },
        { name: 'Estado de Pérdidas y Ganancias', hotelstack: true, competitor: false },
        { name: 'Informe de Ritmo', hotelstack: true, competitor: false },
        { name: 'Facturación Multidivisa', hotelstack: true, competitor: false },
        { name: 'Cumplimiento Fiscal Regional', hotelstack: true, competitor: 'Solo EE.UU.' },
        { name: 'Constructor de Informes Personalizados', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: 'Limitado' },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: 'Básico' },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: false },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: false },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'Los 36 módulos incluidos. Soporte multidivisa global. Precios regionales en EUR, GBP, AED, INR, THB. Incorporación y migración gratuitas.',
    competitorNote: 'Precios bajo presupuesto desde $100+/mes. Enfocado en EE.UU. con funciones internacionales limitadas. Conjunto básico de funciones sin A&B, sin multi-propiedad, sin analíticas avanzadas.',
  },
  advantages: [
    'Cuatro veces más módulos (36 vs 8+) a aproximadamente la mitad del precio inicial',
    'Gestión completa de cadena multi-propiedad — innRoad solo soporta propiedades individuales',
    'Módulo completo de A&B con POS, servicio a habitación, pantalla de cocina y gestión de menú',
    'Gestión avanzada de ingresos con precios dinámicos, previsión y simuladores',
    'Alcance global en más de 40 países vs enfoque solo en EE.UU. de innRoad',
    'Facturación multidivisa y cumplimiento fiscal regional para propiedades internacionales',
    'Programa de fidelización, CRM de huéspedes y comunicaciones automatizadas incluidos',
    'Incorporación y migración de datos gratuitas con soporte dedicado 24/7',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'innRoad es un PMS en la nube directo para hoteles independientes estadounidenses que necesitan gestión básica de reservas y recepción. HotelStack.io ofrece una plataforma mucho más completa con cuatro veces más módulos, soporte multi-propiedad, A&B/POS, herramientas avanzadas de ingresos y alcance global — todo a un precio más bajo. Para cualquier hotel que planee crecer más allá de las necesidades básicas de PMS, HotelStack.io es la elección clara.',
    bestFor: [
      'Hoteles independientes que desean actualizar de PMS básico a plataforma completa',
      'Propiedades que necesitan A&B, POS y herramientas operativas que innRoad no tiene',
      'Hoteles expandiéndose internacionalmente que necesitan herramientas multidivisa y de cumplimiento',
      'Propiedades que desean gestión multi-propiedad para crecimiento futuro',
      'Hoteles que buscan gestión avanzada de ingresos más allá de la configuración básica de tarifas',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de innRoad a HotelStack.io?', answer: 'Sí. Nuestro equipo de migración gestiona la transferencia completa de datos desde innRoad incluyendo perfiles de huéspedes, historial de reservas, planes tarifarios y configuraciones de habitaciones. La migración es gratuita y normalmente se completa en 48 horas sin tiempo de inactividad.' },
    { question: '¿HotelStack.io soporta hoteles independientes en EE.UU. como innRoad?', answer: 'Por supuesto. HotelStack.io soporta hoteles independientes en EE.UU. y más de 40 países. Los hoteles estadounidenses obtienen los 36 módulos incluyendo funciones que innRoad no tiene como A&B/POS, gestión de ingresos y soporte multi-propiedad — desde $49/mes.' },
    { question: '¿Cómo se compara HotelStack.io con innRoad en conectividad GDS?', answer: 'Ambas plataformas ofrecen conectividad GDS vía Amadeus y Sabre. HotelStack.io adicionalmente se conecta a más de 100 OTAs globalmente, ofrece integración de metabuscadores e incluye un motor de reservas sin comisión (BookMyRoom.io) — todo incluido en el precio base.' },
    { question: '¿Puede HotelStack.io gestionar múltiples propiedades a diferencia de innRoad?', answer: 'Sí. HotelStack.io incluye gestión completa de cadena con panel centralizado, analíticas entre propiedades, distribución compartida de tarifas, cumplimiento de estándares de marca e informes consolidados. innRoad está diseñado solo para operaciones de propiedad única.' },
  ],
};

const WEBREZPRO_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io vs WebRezPro',
  heroSubtitle: 'WebRezPro es un PMS canadiense en la nube con enfoque contable dirigido a hoteles pequeños y medianos. HotelStack.io ofrece una plataforma moderna y rica en funciones con 36 módulos, interfaz de nivel empresarial, herramientas avanzadas de ingresos y A&B/POS completo — diseñado para la próxima generación de hospitalidad.',
  overviewComparison: [
    { label: 'Módulos Totales', hotelstack: '36 Módulos Integrados', competitor: 'Más de 10 Funciones Principales' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: 'Desde $75+/mes' },
    { label: 'Calidad UI/UX', hotelstack: 'Moderno Oscuro de Lujo', competitor: 'Funcional / Anticuado' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'No Disponible' },
    { label: 'Gestión de Ingresos', hotelstack: 'Avanzada (Integrada)', competitor: 'Herramientas de Tarifas Básicas' },
    { label: 'Multi-Propiedad', hotelstack: 'Gestión de Cadena Completa', competitor: 'Limitado' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'PMS en la Nube', hotelstack: true, competitor: true },
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Gestión de Reservas', hotelstack: true, competitor: true },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: true },
        { name: 'Gestión de Folio del Huésped', hotelstack: true, competitor: true },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Contabilidad y Finanzas',
      features: [
        { name: 'Contabilidad Integrada', hotelstack: true, competitor: true },
        { name: 'Estado de Pérdidas y Ganancias', hotelstack: true, competitor: true },
        { name: 'Cuentas por Cobrar', hotelstack: true, competitor: true },
        { name: 'Facturación Multidivisa', hotelstack: true, competitor: 'Limitado' },
        { name: 'Cumplimiento Fiscal Regional', hotelstack: true, competitor: 'Enfoque CAD/USD' },
        { name: 'Plantillas de Factura Personalizadas', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Ingresos y Distribución',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'Menos OTAs' },
        { name: 'Reglas de Precios Dinámicos', hotelstack: true, competitor: 'Básico' },
        { name: 'Simulador de Ingresos Hipotético', hotelstack: true, competitor: false },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: false },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: false },
        { name: 'Motor de Reservas Sin Comisión', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'A&B y Operaciones',
      features: [
        { name: 'Terminal POS', hotelstack: true, competitor: false },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: false },
        { name: 'Sistema de Pantalla de Cocina', hotelstack: true, competitor: false },
        { name: 'Gestión de Limpieza', hotelstack: true, competitor: true },
        { name: 'Órdenes de Trabajo de Mantenimiento', hotelstack: true, competitor: false },
        { name: 'Programación de Personal', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Huéspedes y Empresarial',
      features: [
        { name: 'Perfiles de Huésped 360 Grados', hotelstack: true, competitor: 'Básico' },
        { name: 'Gestión de Programa de Fidelización', hotelstack: true, competitor: false },
        { name: 'Automatización de Comunicación con Huéspedes', hotelstack: true, competitor: 'Limitado' },
        { name: 'Panel de Cadena', hotelstack: true, competitor: 'Limitado' },
        { name: 'Analíticas entre Propiedades', hotelstack: true, competitor: false },
        { name: 'Cumplimiento de Estándares de Marca', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: false },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: false },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: false },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: false },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$75+',
    hotelstackNote: 'Los 36 módulos incluidos. Interfaz moderna de nivel empresarial. Precios regionales en EUR, GBP, AED, INR, THB. Incorporación y migración gratuitas.',
    competitorNote: 'Precio por habitación desde $75+/mes CAD. Interfaz funcional pero anticuada. A&B limitado, multi-propiedad limitado, soporte principalmente norteamericano.',
  },
  advantages: [
    'Más del triple de módulos (36 vs 10+) con una interfaz moderna de nivel empresarial',
    'Módulo completo de A&B con POS, servicio a habitación y gestión de cocina incluidos',
    'Gestión avanzada de ingresos con precios dinámicos, previsión y simuladores hipotéticos',
    'Interfaz moderna oscura de lujo diseñada para 2026 vs interfaz funcional pero anticuada de WebRezPro',
    'Gestión completa de cadena multi-propiedad con analíticas centralizadas y distribución de tarifas',
    'Alcance global en más de 40 países vs enfoque norteamericano de WebRezPro',
    'Programa de fidelización, CRM de huéspedes y comunicaciones automatizadas para reservas repetidas',
    'Incorporación y migración de datos gratuitas con soporte dedicado 24/7',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'WebRezPro es un PMS canadiense confiable con sólidas funciones contables para hoteles pequeños y medianos en Norteamérica. Sin embargo, su interfaz anticuada, conjunto limitado de funciones y la falta de A&B, herramientas avanzadas de ingresos y escalabilidad empresarial lo hacen menos competitivo en 2026. HotelStack.io ofrece una plataforma moderna y completa que iguala a WebRezPro en contabilidad mientras añade más de 22 módulos adicionales, una interfaz de clase mundial y capacidades globales.',
    bestFor: [
      'Hoteles que desean una interfaz moderna sin sacrificar profundidad contable',
      'Propiedades que necesitan A&B, POS y gestión de cocina más allá del PMS básico',
      'Hoteles que buscan gestión avanzada de ingresos y herramientas de precios dinámicos',
      'Propiedades expandiéndose internacionalmente más allá de Norteamérica',
      'Grupos hoteleros en crecimiento que necesitan gestión completa de cadena multi-propiedad',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de WebRezPro a HotelStack.io?', answer: 'Sí. Nuestro equipo de migración gestiona la transferencia completa de datos desde WebRezPro incluyendo perfiles de huéspedes, historial de reservas, planes tarifarios, datos contables y configuraciones de habitaciones. La migración es gratuita y normalmente se completa en 48 horas sin tiempo de inactividad.' },
    { question: '¿HotelStack.io iguala las capacidades contables de WebRezPro?', answer: 'Sí. HotelStack.io incluye contabilidad integrada, estados de pérdidas y ganancias, cuentas por cobrar, facturación personalizada y facturación multidivisa. Además, añade más de 22 módulos adicionales incluyendo A&B, gestión de ingresos, CRM de huéspedes y gestión multi-propiedad que WebRezPro no tiene.' },
    { question: '¿Cómo se compara la interfaz de HotelStack.io con WebRezPro?', answer: 'HotelStack.io presenta una interfaz moderna oscura de lujo construida con las últimas tecnologías web, ofreciendo diseño responsivo en todos los dispositivos. WebRezPro tiene una interfaz funcional pero anticuada diseñada para una era anterior de aplicaciones web.' },
    { question: '¿Es HotelStack.io adecuado para propiedades canadienses que usan WebRezPro?', answer: 'Por supuesto. HotelStack.io soporta facturación multidivisa incluyendo CAD, cumplimiento fiscal canadiense (GST/HST/PST), y se conecta a todas las principales OTAs de Norteamérica. Muchas propiedades canadienses cambian por los módulos adicionales y la experiencia moderna.' },
  ],
};


export const COMPARISON_ES_P3B: Record<string, ComparisonConfig> = {
  'hotelstack-vs-innroad': INNROAD_ES,
  'hotelstack-vs-webrezpro': WEBREZPRO_ES,
};
